import { createSlice } from "@reduxjs/toolkit";
import { SLICE } from "../constants/slice";
import { hotelList } from "../constants/hotel";
import CURRENCY_LIST from "../constants/currency";
/**
 * Initial states of Navbar function are defined here
 */
export const initialState = {
  hotel: hotelList[0],
  currency: CURRENCY_LIST[0],
  stayDate: {
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    key: "selection",
  },
};
/**
 * All actions related to Navbar feature are defined here
 */
export const globalSlice = createSlice({
  name: SLICE.GLOBAL,
  initialState,
  reducers: {
    setHotel(state, action) {
      state.hotel = action?.payload;
    },
    setCurrency(state, action) {
      state.currency = action?.payload;
    },
    setStayDate(state, action) {
      state.stayDate = action?.payload;
    }
  },
});
//
export const { actions: globalActions } = globalSlice;
